import { service } from "../utils/request";
// 抖音活动
export function Douyin_List(data) {
	return service({
		url: "manage/douyin.activity/index",
		method: "post",
		data: data,
	});
}
//抖音地理位置
export function douyin_activity(data) {
	return service({
		url: "manage/douyin.activity/poi",
		method: "post",
		data: data,
	});
}
//上传视频
export function up_video(data) {
	return service({
		url: "manage/douyin.video/upload",
		method: "post",
		data: data,
	});
}
//添加活动
export function Douyin_add(data) {
	return service({
		url: "manage/douyin.activity/add",
		method: "post",
		data: data,
	});
}
//活动详情
export function Douyin_detail(data) {
	return service({
		url: "manage/douyin.activity/detail",
		method: "post",
		data: data,
	});
}
//活动详情
export function Douyin_detail2(data) {
	return service({
		url: "manage/douyin.activity/reward_detail",
		method: "post",
		data: data,
	});
}
//编辑活动
export function Douyin_edit(data) {
	return service({
		url: "manage/douyin.activity/edit",
		method: "post",
		data: data,
	});
}
//删除活动
export function Douyin_del(data) {
	return service({
		url: "manage/douyin.activity/del",
		method: "post",
		data: data,
	});
}
//门店
export function Douyin_room(data) {
	return service({
		url: "offlinestore/user.store/index",
		method: "post",
		data: data,
	});
}
//奖励规则
export function reward_roles(data) {
	return service({
		url: "manage/douyin.activity/reward",
		method: "post",
		data: data,
	});
}
//视频库
export function video_getList(data) {
	return service({
		url: "manage/douyin.video/getList",
		method: "post",
		data: data,
	});
}
//视频库
export function video_del(data) {
	return service({
		url: "manage/douyin.video/delVideo",
		method: "post",
		data: data,
	});
}
//播放列表
export function Dy_PlayList(data) {
	return service({
		url: "manage/douyin.logs/index",
		method: "post",
		data: data,
	});
}
//统计
export function Dy_statistics(data) {
	return service({
		url: "manage/douyin.logs/count",
		method: "post",
		data: data,
	});
}
